const Keyboard = {
  dismiss() {
    return;
  },
};

export default Keyboard;
